export * from './umpire-component-text';
